<template>
  <div class="bindCar">
    <div class="car-img">
      <img style="width: 100%; height: 100%" :src="carImgUrl" />
    </div>
    <div class="info" v-if="type==0">
      <label>您正在为{{carNum}}进行申诉</label>
    </div>
   <div class="car-info" v-if="type==1">
      <van-cell-group>
        <van-field v-model="carNum" label="车牌号:" type="text" readonly input-align="right" />
        <van-field v-model="carCode" label="车辆识别码:" placeholder="请输入车辆识别码" type="text" input-align="right" />
        <van-field v-model="engineCode" label="发动机号:" placeholder="请输入发动机号" type="text" input-align="right" />
      </van-cell-group>
    </div>

    <div class="bt_bind1" v-if="type==0">
      <van-uploader :after-read="onRead">
        <van-button   color="#2E9AFE">拍照上传行驶证</van-button>
      </van-uploader>
    </div>
    <van-button v-if="type==1" class="bt_bind" color="#2E9AFE" @click="appeal">立即申诉</van-button>



  </div>
</template>

<script>
  import {
    Dialog
  } from 'vant';
    import { mySessionStorage } from '@/utils/storage.js'
  import api from "../../../http/api";
  export default {
    name: "appeal",
    data() {
      return {
        type:0,//0 拍照 1申诉
        title: "",
        carNum: "川F22QP0",
        carCode: "",
        engineCode: "",
        carImgUrl: "../static/img/carBlue.png",
        openid:123456,
        fd : new FormData()
      };
    },
    methods: {
      onClickLeft() {
        console.log("返回");
        this.$router.push("/menu");
      },
      appeal() {

        if(this.carCode == '' || this.engineCode ==''){
          Dialog.alert({
            message:'车辆识别码和发动机号码不能为空!!!!'
          });

          return;
        }
        this.fd.append('carCode',this.carCode);
        this.fd.append('engineCode',this.engineCode);
        this.$uploadImg.post(this.$api.carInfoUpload,this.fd)
          .then(res => {
            console.log(res);
            if(res.code==200){
              this.$toast.success(res.msg);
              this.$router.push("/appealInfo");              
            }
            else{
              this.$toast.fail(res.msg);
            }
          })
          .catch(err => {
            console.log("上传接口服务器异常");
            this.$toast.fail("图片过大或服务器异常");
          });

        // this.$axios.post(this.$api.carInfoUpload,
        //   this.fd,
        //   { headers:{
        //       'Content-Type':'multipart/form-data',
        //       'Authorization':'Basic Y3RwYXJrOmN0cGFyaw==',
        //       'authority':''
        //     }}
        // ).then(res=>{
        //     console.log(res);
        //     if(res.data.code == '200'){
        //       Dialog.alert({
        //         message:res.data.msg
        //       });

        //       this.$router.push("/appealInfo");
        //     }else {
        //       Dialog.alert({
        //         message:res.data.msg
        //       });
        //     }
        // })

      },
      onRead(file){
        this.carImgUrl  = file.content;
        this.fd.append('filenames',file.file);
        this.fd.append('carNum',this.carNum);
        this.fd.append('openid',this.openid);
        this.type = 1;
      }
    },
    created() {
      this.carNum = this.$route.query.carNum + "";
      this.openid=mySessionStorage.getItem("openid");
    }
  };
</script>

<style scoped>
  .bindCar {
    min-height: 100%;
    height: 200%;
    width: 100%;
    max-width: 100%;
    background-color: #e8e9eb;
    float: left;
  }

  .adsense_space {
    width: 100%;
    height: 25%;
  }

  .adsense_space img {
    height: 100%;
    width: 100%;
  }

  .bt_bind {
    width: 80%;
    margin: 30px 10%;
    border-radius: 5px;
    height: 36px;
    /* position: fixed;
  display: block; */
  }

  .bt_bind1 {
    width: 80%;
    margin: 30px 10%;
    margin-left: 30%;
    border-radius: 5px;
    height: 36px;
    /* position: fixed;
  display: block; */
  }

  .car-img {
    text-align: center;
    margin: 3% auto 3%;
    width: 350px;
    height: 200px;
    padding: 0px 15px;
    background-color: white;
  }
  .car-info{
    margin: 0 4%;
  }

  .info {
    text-align: center;
    height: 36px;
    color: gray;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/bind/appeal.vue